import Route from '@ember/routing/route'

export default class BookingInfoRoute extends Route {}
